import { Outlet, useParams } from "react-router-dom";
import PomoCustomer from "./PromotionCustomer/Promo";

const Tab6 = () => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PomoCustomer />;
};

export default Tab6;
